(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haga-cart"] && !Shopify.designMode) return;
  try {
    
  function initHagaCartPage() {
    const page = document.querySelector('.haga-cart-page');
    if (!page || page.dataset.initialized) return;
    page.dataset.initialized = 'true';

    const button = page.querySelector('[data-haga-open-cart]');
    customElements.whenDefined('cart-drawer-component').then(() => {
      function openCart() {
        const drawer = document.querySelector('.haga-header__cart-drawer');
        if (!drawer) return;
        button.focus({ preventScroll: true });
        drawer.open();
      }
      button.addEventListener('click', openCart);
      if (!window.Shopify?.designMode) openCart();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHagaCartPage, { once: true });
  } else {
    initHagaCartPage();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-category-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(bar) {
      if (bar.dataset.catbarInit) return;
      bar.dataset.catbarInit = '1';
      var list = bar.querySelector('.haga-category-bar__list');
      if (!list) return;
      // bring the current category into view (instant — runs on load, so no motion to guard)
      var cur = list.querySelector('.haga-category-bar__link.is-current');
      if (cur && list.scrollWidth > list.clientWidth) cur.scrollIntoView({ block: 'nearest', inline: 'center' });
      // fade only the edge(s) that still have hidden tabs
      function fades() {
        var max = list.scrollWidth - list.clientWidth;
        var over = max > 1;
        list.style.setProperty('--fade-l', over && list.scrollLeft > 1 ? 'var(--fade)' : '0px');
        list.style.setProperty('--fade-r', over && list.scrollLeft < max - 1 ? 'var(--fade)' : '0px');
      }
      list.addEventListener('scroll', fades, { passive: true });
      window.addEventListener('resize', fades);
      fades();
    }
    function init() { document.querySelectorAll('.haga-category-bar').forEach(setup); }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-footer"] && !Shopify.designMode) return;
  try {
    
  // The elephant autoplays (always visible), but there's no reason to keep decoding frames while the
  // footer is off-screen at the foot of a long page. Pause it when it leaves the viewport, resume when
  // it re-enters (unless reduced-motion, where the haga-section tamer keeps it paused). Progressive
  // enhancement — without JS the markup's autoplay just keeps looping.
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('.haga-footer__video').forEach(function (video) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            video.pause();
          } else if (!reduce.matches) {
            var p = video.play();
            if (p && p.catch) { p.catch(function () {}); }
          }
        });
      }, { threshold: 0.1 });
      io.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-form"] && !Shopify.designMode) return;
  try {
    
  /* Progressive enhancement: Shopify reloads the page on a submit error, and `form` is out of scope
     in a content_for block so Liquid can't repopulate the fields — a bad e-mail wipes everything the
     user typed. Snapshot values on submit, restore them when the page returns with an error, clear on
     success. Degrades gracefully: no JS = the form still works (it just loses values on error, as before). */
  /* FORGIVING VALIDATION (latent — nothing to do today): no field is format-checked. IF a format check
     is ever added (orgnr, postnummer, telefon), strip separators (hyphens, spaces) BEFORE validating so a
     value passes with or without them. Don't reject recoverable formatting (GOV.UK pattern). */
  (function () {
    function init() {
      var form = document.querySelector('.haga-form form');
      if (!form) return;
      var KEY = 'haga-form:' + location.pathname;
      var fields = function () { return form.querySelectorAll('input[name], textarea[name]'); };
      try {
        if (document.querySelector('.haga-form__note--ok')) {
          sessionStorage.removeItem(KEY);
        } else if (document.querySelector('.haga-form__note--error')) {
          var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
          if (saved) {
            fields().forEach(function (el) {
              if (el.type !== 'hidden' && !el.value && saved[el.name] != null) el.value = saved[el.name];
            });
          }
        }
      } catch (e) {}
      form.addEventListener('submit', function () {
        try {
          var data = {};
          fields().forEach(function (el) { if (el.type !== 'hidden') data[el.name] = el.value; });
          sessionStorage.setItem(KEY, JSON.stringify(data));
        } catch (e) {}
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-haga-drawer-open]');
    if (opener) {
      const drawer = document.querySelector('.haga-header__drawer');
      if (drawer && typeof drawer.showModal === 'function') drawer.showModal();
      opener.setAttribute('aria-expanded', 'true');
      return;
    }
    const closer = event.target.closest('[data-haga-drawer-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }
    const open = document.querySelector('.haga-header__drawer[open]');
    if (open && event.target === open) open.close();
  });
  // Reflect the drawer's open state on the burger for screen readers. The dialog 'close' event
  // covers every close path (button, backdrop, Esc), so we only need to set true on open.
  document.querySelector('.haga-header__drawer')?.addEventListener('close', () => {
    document.querySelector('[data-haga-drawer-open]')?.setAttribute('aria-expanded', 'false');
  });

  /* keep the header cart count live: Horizon broadcasts 'cart:update' carrying the new itemCount (the
     same event cart-icon + haga-pickup already use). The server-rendered count only reflects page-load. */
  document.addEventListener('cart:update', (event) => {
    const count = event.detail && event.detail.data ? event.detail.data.itemCount : undefined;
    if (typeof count !== 'number') return;
    document.querySelectorAll('.haga-header__cart-count').forEach((el) => { el.textContent = count; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-pickup"] && !Shopify.designMode) return;
  try {
    
  // Pickup details for the DRAWER cart (and the /cart page). ARCHITECTURE (ultracode 2026-06):
  // ONE node (<haga-pickup-dock>, always rendered in the hidden footer source) held by ONE
  // JS reference for the page lifetime. PRESENCE is a synchronous, idempotent ensureDocked()
  // driven by a body-wide MutationObserver, rAF-COALESCED — a burst of body mutations collapses
  // into ONE ensureDocked per animation frame; rAF runs BEFORE PAINT, so the node is never visibly
  // missing; every write is check-then-write, so a settled DOM produces zero mutations (no loops).
  // FRESHNESS (min lead days) is
  // a separate debounced, sequence-guarded ?sections= fetch that only copies DATA onto the
  // live node — it never creates, removes, or replaces nodes. The old dock()/init()/refresh()
  // node surgery, the dialog observer, its debounce/inFlight/failure-cap: all deleted.
  (function () {
    var DAYS = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
    var MONTHS = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
    var saveTimer = null, refreshTimer = null, seq = 0, submitting = false;
    var savePending = Promise.resolve(), activeCheckout = null, cartChanging = false;

    var dockEl = document.getElementById('HagaPickupDock');
    if (!dockEl) return;
    var sourceEl = dockEl.closest('.haga-pickup-source');
    var sectionId = sourceEl && sourceEl.dataset.sectionId;
    function $(r, ref) { return r.querySelector('[data-ref="' + ref + '"]'); }

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function dayLabel(d) {
      var s = DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
      if (d.getFullYear() !== nowSthlm().getFullYear()) s += ' ' + d.getFullYear();
      return s;
    }
    function toMin(t) {
      if (!t) return null;
      var p = String(t).split(/[:.]/);                 // accept "07:00" or Swedish-period "07.00"
      if (p.length < 2) return null;
      var h = parseInt(p[0], 10), m = parseInt(p[1], 10);
      if (isNaN(h) || isNaN(m)) return null;
      return h * 60 + m;
    }
    // OPTION 2: ONE standard weekly-hours map (from the dock's data-hours), not per-store.
    function storeHours(r) {
      try { return JSON.parse(r.dataset.hours || 'null'); } catch (e) { return null; }
    }
    function openRange(hours, day) {
      var h = hours && hours[String(day)];
      var open = toMin(h && h[0]), close = toMin(h && h[1]);
      if (open === null || close === null || close <= open) return null;
      return [open, close];
    }
    // "Now" in Europe/Stockholm wall-clock (only Y/M/D/H/M fields are used). The cutoff is STORE time,
    // not the customer's browser time; this also removes the near-midnight off-by-one for the date list.
    function nowSthlm() {
      // WebKit-safe: toLocaleString()+new Date() returns Invalid Date in Safari/iOS (U+202F separator),
      // which would empty the whole date list. Build from numeric parts instead. Only Y/M/D/H/M are used.
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Stockholm', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
        var f = {};
        for (var i = 0; i < parts.length; i++) { if (parts[i].type !== 'literal') f[parts[i].type] = parts[i].value; }
        return new Date(+f.year, f.month - 1, +f.day, (+f.hour) % 24, +f.minute, 0);   // hour '24'→0 (some engines emit 24 at midnight)
      } catch (e) { return new Date(); }
    }
    function isLeadDay(d, closed, lastWeekday) {
      var wd = d.getDay();
      return wd >= 1 && wd <= lastWeekday && closed.indexOf(iso(d)) === -1;
    }
    function countLeadDays(reference, days, closed, lastWeekday, normalizeStart) {
      var d = new Date(reference), guard = 0;
      // Cakes begin on a production day. Sandwich cakes retain their original reference-day rule.
      while (normalizeStart && !isLeadDay(d, closed, lastWeekday) && guard++ < 366) d.setDate(d.getDate() + 1);
      var counted = 0;
      while (counted < days && guard++ < 366) {
        d.setDate(d.getDate() + 1);
        if (isLeadDay(d, closed, lastWeekday)) counted++;
      }
      return counted === days ? d : new Date(NaN);
    }
    // Shared by the picker and checkout validation. Compare dates, not numbers from different calendars.
    function earliestDate(r) {
      var closed = (r.dataset.closedDates || '').split(/[\s,]+/);
      var cakeDays = parseInt(r.dataset.cakeDays, 10);
      var otherDays = parseInt(r.dataset.otherDays, 10);
      var cutoff = toMin(r.dataset.cutoff);
      var reference = nowSthlm();
      // Preserve the existing cutoff: the 15:00 minute is included; 15:01 rolls to tomorrow.
      if (cutoff !== null && (reference.getHours() * 60 + reference.getMinutes()) > cutoff) reference.setDate(reference.getDate() + 1);
      reference.setHours(0, 0, 0, 0);
      var earliest = null;
      if (cakeDays >= 0) earliest = countLeadDays(reference, Math.max(1, cakeDays), closed, 6, true);
      if (otherDays >= 0) {
        var other;
        if (otherDays <= 1) {
          other = new Date(reference);
          other.setDate(other.getDate() + 1);
        } else {
          other = countLeadDays(reference, otherDays, closed, 5, false);
        }
        if (!earliest || other > earliest || isNaN(other.getTime())) earliest = other;
      }
      return earliest || new Date(NaN);
    }
    function populateDates(r) {
      var date = $(r, 'date'), hours = storeHours(r);
      var keep = date.dataset.selected || date.value;
      var closed = (r.dataset.closedDates || '').split(/[\s,]+/);     // blackout ISO dates (Stängda datum)
      var closedWk = (r.dataset.closedWeekdays || '').split(/[\s,]+/); // per-product no-pickup weekdays (getDay nums)
      date.innerHTML = '';
      date.disabled = false;
      date.add(new Option('Välj datum', '', true, true));
      date.options[0].disabled = true;
      var windowDays = parseInt(r.dataset.window, 10) || 14;
      var d = earliestDate(r);
      // Collect up to windowDays OPEN days (not a fixed calendar span) so Sundays/blackouts/closed-weekdays
      // inside the range don't starve the list into a false "Inga lediga dagar"; scan-capped so it can't run away.
      var added = 0, scan = 0, prevWeekKey = null;
      while (added < windowDays && scan++ < windowDays * 6) {
        var v = iso(d);
        if (openRange(hours, d.getDay()) && closed.indexOf(v) === -1 && closedWk.indexOf(String(d.getDay())) === -1) {
          var mon = new Date(d); mon.setDate(mon.getDate() - ((mon.getDay() + 6) % 7));   // Monday of this date's week
          var weekKey = iso(mon);
          if (prevWeekKey !== null && weekKey !== prevWeekKey) date.appendChild(document.createElement('hr'));   // bare week divider (lördag│måndag). <hr> in <select>: Chrome + recent Safari render it; others ignore it harmlessly. Fallback = a disabled "──────" option.
          date.add(new Option(dayLabel(d), v, false, v === keep));
          prevWeekKey = weekKey;
          added++;
        }
        d.setDate(d.getDate() + 1);
      }
      if (date.options.length <= 1) {   // no open days at all (long closure / misconfigured hours)
        date.disabled = true;
        date.options[0].text = 'Inga lediga dagar';
      }
      if (date.value) date.dataset.selected = date.value;
    }
    function fillSlots(r) {
      var time = $(r, 'time'), date = $(r, 'date'), hours = storeHours(r);
      var keep = (time.dataset.selected || time.value || '').replace(':', '.');   // legacy colon-time still matches new period labels
      var interval = parseInt(r.dataset.interval, 10) || 60;
      var buffer = parseInt(r.dataset.buffer, 10);
      if (isNaN(buffer)) buffer = 30;                   // minutes before close for the LAST slot (handover buffer)
      time.innerHTML = '';
      var hrs = (hours && date.value) ? openRange(hours, new Date(date.value + 'T12:00:00').getDay()) : null;
      if (!hrs) {
        time.disabled = true;
        time.add(new Option('Välj datum först', '', true, true));
        return;
      }
      time.disabled = false;
      time.add(new Option('Välj klockslag', '', true, !keep));
      time.options[0].disabled = true;
      for (var t = hrs[0]; t <= hrs[1] - buffer; t += interval) {
        var label = pad(Math.floor(t / 60)) + '.' + pad(t % 60);   // Swedish time uses a period (kl. 07.00), per Skrivregler
        time.add(new Option(label, label, false, label === keep));
      }
      if (time.value) time.dataset.selected = time.value;
    }
    // Re-derive date/time options against TODAY's lead-time floor; if the previously-chosen date now
    // falls below it, retract the selection (clear saved date+time, persist). Shared by the min-days
    // refresh and the submit-time stale-date guard. Returns true if it retracted a date.
    function retractStaleDate(r) {
      var date = $(r, 'date');
      var had = date.dataset.selected || date.value;
      populateDates(r);
      fillSlots(r);
      if (had && !date.value) {
        delete date.dataset.selected;
        delete $(r, 'time').dataset.selected;
        save();
        return true;
      }
      return false;
    }
    function validate(r, show) {
      var errs = 0;
      // selRef pairs each error with its select so we can mirror state onto aria-invalid —
      // only flips true once the gate has actually fired (show), never mid-selection.
      function flag(selRef, errRef, bad) {
        var err = $(r, errRef);
        err.hidden = !(bad && show);
        var sel = $(r, selRef);
        if (sel) sel.setAttribute('aria-invalid', (bad && show) ? 'true' : 'false');
        if (bad) errs++;
      }
      flag('date', 'dateError', !$(r, 'date').value);
      flag('time', 'timeError', !$(r, 'time').value);
      r.classList.toggle('haga-pickup--invalid', errs > 0 && show);
      var status = $(r, 'status');                       // SR live region (assertive) — reserved for the retract-date message
      if (status) status.textContent = '';               // a11y: the gate-fire is announced by the per-field role=alert errors (date + time); writing a 3rd summary here fired THREE simultaneous assertive announcements. Clear-only — never add the summary back.
      return errs === 0;
    }
    // Move keyboard/SR focus to the first EMPTY enabled select (store → date → time); disabled
    // date/time are skipped, so an empty store always wins. preventScroll lets revealDock own the
    // motion. Pair with the role="alert" errors so SR users both hear and land on the problem.
    function focusFirstInvalid(r) {
      var refs = ['date', 'time'];
      for (var i = 0; i < refs.length; i++) {
        var sel = $(r, refs[i]);
        if (sel && !sel.disabled && !sel.value) { sel.focus({ preventScroll: true }); return; }
      }
    }
    // Honour prefers-reduced-motion on the error scroll.
    function revealDock() {
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dockEl.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' });
    }
    function pickupError(message) {
      var error = new Error(message);
      error.pickupMessage = message;
      return error;
    }
    function showSaveError(message) {
      var field = $(dockEl, 'saveError');
      if (field) field.textContent = message;
    }
    function cartURL(action) {
      return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart' + action + '.js';
    }
    function requestJSON(url, options, signal) {
      return new Promise(function (resolve, reject) {
        var controller = new AbortController();
        var settled = false;
        var timer = setTimeout(function () { fail(new Error('Request timed out')); }, 10000);
        function clean() {
          clearTimeout(timer);
          if (signal) signal.removeEventListener('abort', aborted);
        }
        function fail(error) {
          if (settled) return;
          settled = true;
          clean();
          controller.abort();
          reject(error);
        }
        function aborted() { fail(new Error('Request cancelled')); }
        if (signal) {
          if (signal.aborted) { aborted(); return; }
          signal.addEventListener('abort', aborted, { once: true });
        }
        fetch(url, Object.assign({}, options, { signal: controller.signal, cache: 'no-store' }))
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            return response.json();
          })
          .then(function (json) {
            if (settled) return;
            settled = true;
            clean();
            resolve(json);
          }).catch(fail);
      });
    }
    function writeCart(action, body, signal) {
      return requestJSON(cartURL(action), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }, signal);
    }
    function pickupAttributes(choice) {
      return { 'Upphämtningsdatum': choice.date, 'Upphämtningstid': choice.time };
    }
    function currentChoice() {
      return { date: $(dockEl, 'date').value || '', time: $(dockEl, 'time').value || '' };
    }
    function save() {
      clearTimeout(saveTimer);
      if (submitting) return;
      saveTimer = setTimeout(function () {
        var choice = currentChoice();
        savePending = savePending.catch(function () {}).then(function () {
          return writeCart('/update', { attributes: pickupAttributes(choice) });
        }).then(function () {
          if (!submitting) showSaveError('');
        }).catch(function () {
          if (!submitting) showSaveError('Kunde inte spara upphämtningstiden, försök igen.');
        });
      }, 300);
    }

    // The submit-time mirror is FOR CHECKOUT — in our own UI it would only go stale.
    function hideMirror() {
      document.querySelectorAll('.haga-cart__property dt').forEach(function (dt) {
        if (dt.textContent.indexOf('Upphämtning') === 0 && dt.parentElement.style.display !== 'none') {
          dt.parentElement.style.display = 'none';
        }
      });
    }

    // PRESENCE: idempotent, synchronous, zero-state. Cosmetics can never break docking.
    function cosmetics(target, inDrawer) {
      hideMirror();
      if (inDrawer) {
        // the total sits right above the button — repeating it on Betala was redundant (user 2026-06-13)
        var btn = target.querySelector('#checkout .button-text');
        if (btn && !submitting && btn.textContent.trim() !== 'Betala') btn.textContent = 'Betala';
      }
    }
    // SELF-DETECT GUARD (2026-06-23): on a NON-empty cart, failing to find the attach target almost
    // always means Horizon renamed .cart-drawer__summary / .cart-page__summary in a theme update.
    // Surface it loudly (console + a <html data-haga-pickup-dock="attach-failed"> flag) instead of
    // silently parking the picker. Debounced 1.2s so a transient mid-render frame never false-alarms;
    // self-clears the moment the dock attaches again. See pickup-system.md → Runbook.
    var detachTimer = null, detachFlagged = false;
    function cartHasItems() { return !!document.querySelector('.haga-cart__table-row, .cart-item'); }
    function clearDetachFlag() {
      if (detachTimer) { clearTimeout(detachTimer); detachTimer = null; }
      if (detachFlagged) { detachFlagged = false; document.documentElement.removeAttribute('data-haga-pickup-dock'); }
    }
    function flagPossibleDetach() {
      if (detachFlagged || detachTimer) return;
      detachTimer = setTimeout(function () {
        detachTimer = null;
        var stillBroken = !document.querySelector('.cart-page .cart-page__summary, .cart-drawer__summary') && cartHasItems();
        if (!stillBroken) return;
        detachFlagged = true;
        document.documentElement.setAttribute('data-haga-pickup-dock', 'attach-failed');
        try { console.error('[haga-pickup] dock could not attach to a non-empty cart — Horizon may have renamed .cart-drawer__summary / .cart-page__summary in a theme update; the pickup picker is hidden. See pickup-system.md → Runbook.'); } catch (e) {}
      }, 1200);
    }

    function ensureDocked() {
      var target = document.querySelector('.cart-page .cart-page__summary')
                || document.querySelector('.cart-drawer__summary');
      if (!target) {
        // nothing to dock into → park back in the hidden source, STILL in-document so
        // form="cart-form" attribute submission keeps working. Distinguish the two cases:
        // genuinely empty cart (expected, silent) vs items present but no target (likely Horizon change → flag).
        if (cartHasItems()) flagPossibleDetach(); else clearDetachFlag();
        if (sourceEl && dockEl.parentNode !== sourceEl) sourceEl.appendChild(dockEl);
        return;
      }
      clearDetachFlag();
      var inDrawer = !target.classList.contains('cart-page__summary');
      dockEl.classList.toggle('haga-pickup--drawer', inDrawer);
      dockEl.classList.toggle('haga-pickup--page', !inDrawer);
      if (target.previousElementSibling !== dockEl) target.parentNode.insertBefore(dockEl, target);
      try { cosmetics(target, inDrawer); } catch (e) {}
      if (activeCheckout) lockCheckout(activeCheckout);
    }

    async function readRules(signal) {
      if (!sectionId) throw new Error('Missing pickup section');
      var url = new URL(window.location.href);
      url.searchParams.set('sections', sectionId);
      var json = await requestJSON(url.toString(), {}, signal);
      var html = json && json[sectionId];
      if (typeof html !== 'string' || !html) throw new Error('Missing pickup rules');
      var probe = document.createElement('div');
      probe.innerHTML = html;
      var fresh = probe.querySelector('#HagaPickupDock');
      if (!fresh) throw new Error('Invalid pickup rules');
      var data = {};
      ['cakeDays', 'otherDays', 'closedWeekdays', 'closedDates', 'hours', 'cutoff', 'interval', 'buffer', 'window'].forEach(function (key) {
        if (fresh.dataset[key] === undefined) throw new Error('Incomplete pickup rules');
        data[key] = fresh.dataset[key];
      });
      if (![data.cakeDays, data.otherDays].every(function (value) { return /^(?:-1|\d+)$/.test(value); }) || (data.cakeDays === '-1' && data.otherDays === '-1')) throw new Error('Invalid pickup lead times');
      if (!JSON.parse(data.hours)) throw new Error('Invalid pickup hours');
      return data;
    }
    function applyRules(data) {
      Object.keys(data).forEach(function (key) { dockEl.dataset[key] = data[key]; });
      var retracted = retractStaleDate(dockEl);
      if (retracted) {
        var status = $(dockEl, 'status');
        if (status) status.textContent = 'Upphämtningsdagen är inte längre tillgänglig. Välj en ny dag.';
      }
      return retracted;
    }
    function refreshData() {
      var mySeq = ++seq;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        readRules().then(function (data) {
          if (mySeq !== seq || submitting) return;
          applyRules(data);
          showSaveError('');
        }).catch(function () {
          if (mySeq !== seq || submitting) return;
          showSaveError('Kunde inte kontrollera tillgängliga dagar. Försök igen genom att trycka på Betala.');
        });
      }, 250);
    }

    // boot
    populateDates(dockEl);
    fillSlots(dockEl);
    ensureDocked();

    // the repair loop: post-morph, pre-paint — the node is never visibly missing. rAF-coalesce so a
    // BURST of body mutations (header dropdowns, lazy images, third-party pixels) collapses into ONE
    // ensureDocked per frame, instead of running it — and its document-wide cosmetics() — on every
    // single mutation. rAF fires BEFORE paint, so the pre-paint "never visibly missing" guarantee
    // still holds; ensureDocked is idempotent, so its own insertBefore settles in one no-op frame.
    var dockScheduled = false;
    function scheduleDock() {
      if (dockScheduled) return;
      dockScheduled = true;
      requestAnimationFrame(function () { dockScheduled = false; ensureDocked(); });
    }
    new MutationObserver(scheduleDock).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', function (e) {
      if (!dockEl.contains(e.target)) return;
      if (activeCheckout) finishCheckout(activeCheckout, 'Upphämtningsvalet har ändrats. Tryck på Betala igen.');
      var ref = e.target.dataset.ref;
      if (ref === 'date') { e.target.dataset.selected = e.target.value; fillSlots(dockEl); validate(dockEl, false); save(); }
      else if (ref === 'time') { e.target.dataset.selected = e.target.value; validate(dockEl, false); save(); }
    });

    function cartFingerprint(cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) throw new Error('Invalid or empty cart');
      var groups = {};
      cart.items.forEach(function (item) {
        if (!item.key || !item.variant_id || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Invalid cart line');
        var props = Object.keys(item.properties || {}).filter(function (key) { return key !== 'Upphämtning'; }).sort().map(function (key) {
          return [key, item.properties[key]];
        });
        var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
        var identity = JSON.stringify([item.variant_id, plan && plan.id || null, props]);
        groups[identity] = (groups[identity] || 0) + item.quantity;
      });
      return JSON.stringify(Object.keys(groups).sort().map(function (key) { return [key, groups[key]]; }));
    }
    function lockCheckout(op) {
      var form = document.getElementById('cart-form');
      if (form) op.form = form;
      [op.form, dockEl].forEach(function (node) {
        if (!op.inertNodes.some(function (entry) { return entry.node === node; })) {
          op.inertNodes.push({ node: node, inert: node.hasAttribute('inert') });
        }
        if (!node.hasAttribute('inert')) node.setAttribute('inert', '');
      });
      var button = document.querySelector('#checkout');
      if (!button) return;
      var textEl = button.querySelector('.button-text') || button;
      if (!op.buttons.some(function (entry) { return entry.node === button; })) {
        op.buttons.push({ node: button, disabled: button.disabled, textEl: textEl, text: textEl.textContent });
      }
      if (!button.disabled) button.disabled = true;
      if (button.getAttribute('aria-busy') !== 'true') button.setAttribute('aria-busy', 'true');
      if (textEl.textContent !== 'Till kassan…') textEl.textContent = 'Till kassan…';
    }
    function assertCheckout(op) {
      if (activeCheckout !== op || op.controller.signal.aborted) throw new Error('Checkout cancelled');
      if (cartChanging || document.querySelector('cart-items-component.cart-items-disabled')) throw pickupError('Vänta tills varukorgen har uppdaterats och tryck på Betala igen.');
      lockCheckout(op);
      var choice = currentChoice();
      if (!op.form.isConnected || choice.date !== op.choice.date || choice.time !== op.choice.time) {
        throw pickupError('Upphämtningsvalet eller varukorgen har ändrats. Kontrollera valet och tryck på Betala igen.');
      }
    }
    function verifyCart(cart, op, complete) {
      assertCheckout(op);
      if (cartFingerprint(cart) !== op.fingerprint) throw pickupError('Varukorgen har ändrats. Kontrollera upphämtningen och tryck på Betala igen.');
      if (complete && (cart.items.some(function (item) { return !item.properties || item.properties['Upphämtning'] !== op.summary; }) ||
          !cart.attributes || cart.attributes['Upphämtningsdatum'] !== op.choice.date || cart.attributes['Upphämtningstid'] !== op.choice.time)) {
        throw new Error('Pickup was not saved');
      }
    }
    function finishCheckout(op, message) {
      if (activeCheckout !== op) return;
      activeCheckout = null;
      submitting = false;
      clearTimeout(op.timer);
      op.controller.abort();
      op.inertNodes.forEach(function (entry) {
        if (!entry.inert) entry.node.removeAttribute('inert');
      });
      op.buttons.forEach(function (entry) {
        entry.node.disabled = entry.disabled;
        entry.node.removeAttribute('aria-busy');
        entry.textEl.textContent = entry.text;
      });
      if (message) { showSaveError(message); revealDock(); focusFirstInvalid(dockEl); }
    }
    async function prepareCheckout(op) {
      await savePending;
      assertCheckout(op);
      var cart = await requestJSON(cartURL(''), {}, op.controller.signal);
      assertCheckout(op);
      op.fingerprint = cartFingerprint(cart);
      var rules = await readRules(op.controller.signal);
      assertCheckout(op);
      applyRules(rules);
      if (!validate(dockEl, true)) throw pickupError('Upphämtningstiden är inte längre tillgänglig. Välj datum och tid igen.');
      assertCheckout(op);
      var date = $(dockEl, 'date');
      op.summary = date.options[date.selectedIndex].text + ' kl. ' + op.choice.time;
      var limit = cart.items.length + 5;
      var item;
      while ((item = cart.items.find(function (line) { return !line.properties || line.properties['Upphämtning'] !== op.summary; }))) {
        if (--limit < 0) throw new Error('Pickup synchronization did not settle');
        assertCheckout(op);
        cart = await writeCart('/change', {
          id: item.key,
          quantity: item.quantity,
          properties: Object.assign({}, item.properties, { 'Upphämtning': op.summary })
        }, op.controller.signal);
        verifyCart(cart, op, false);
      }
      cart = await writeCart('/update', { attributes: pickupAttributes(op.choice) }, op.controller.signal);
      verifyCart(cart, op, true);
      cart = await requestJSON(cartURL(''), {}, op.controller.signal);
      verifyCart(cart, op, true);
      retractStaleDate(dockEl);
      if (!validate(dockEl, true)) throw pickupError('Upphämtningstiden är inte längre tillgänglig. Välj datum och tid igen.');
      assertCheckout(op);
      if (!op.form.querySelector('input[type="hidden"][name="checkout"]')) {
        var intent = document.createElement('input');
        intent.type = 'hidden';
        intent.name = 'checkout';
        op.form.appendChild(intent);
      }
      clearTimeout(op.timer);
      op.timer = setTimeout(function () {
        finishCheckout(op, 'Kassan öppnades inte. Försök igen.');
      }, 8000);
      op.form.submit();
    }
    document.addEventListener('submit', function (e) {
      if (!(e.target && e.target.id === 'cart-form')) return;
      e.preventDefault();
      if (submitting) return;
      if (cartChanging || document.querySelector('cart-items-component.cart-items-disabled')) {
        showSaveError('Varukorgen uppdateras. Vänta och försök igen. Ladda om sidan om uppdateringen inte blir klar.');
        return;
      }
      if (!validate(dockEl, true)) { revealDock(); focusFirstInvalid(dockEl); return; }
      clearTimeout(saveTimer);
      clearTimeout(refreshTimer);
      ++seq;
      var op = {
        form: e.target, choice: currentChoice(), controller: new AbortController(),
        inertNodes: [], buttons: []
      };
      activeCheckout = op;
      submitting = true;
      showSaveError('');
      lockCheckout(op);
      op.timer = setTimeout(function () {
        finishCheckout(op, 'Det tog för lång tid att spara upphämtningen. Försök igen.');
      }, 45000);
      prepareCheckout(op).catch(function (error) {
        if (activeCheckout === op) console.warn('[haga-pickup] checkout stopped:', error.message);
        finishCheckout(op, error.pickupMessage || 'Kunde inte kontrollera och spara upphämtningen. Försök igen.');
      });
    });

    document.addEventListener('quantity-selector:update', function (e) {
      if (!e.target.closest || !e.target.closest('#cart-form')) return;
      cartChanging = true;
      if (activeCheckout) finishCheckout(activeCheckout, 'Varukorgen har ändrats. Kontrollera upphämtningen och tryck på Betala igen.');
    });
    document.addEventListener('cart:error', function () { cartChanging = false; });
    document.addEventListener('cart:update', function (e) {
      cartChanging = false;
      if (activeCheckout) {
        var resource = e.detail && e.detail.resource;
        try {
          if (resource && cartFingerprint(resource) === activeCheckout.fingerprint) {
            requestAnimationFrame(ensureDocked);
            return;
          }
        } catch (error) {}
        console.warn('[haga-pickup] checkout stopped by cart event');
        finishCheckout(activeCheckout, 'Varukorgen har ändrats. Kontrollera upphämtningen och tryck på Betala igen.');
      }
      requestAnimationFrame(ensureDocked);
      refreshData();
    });

    // theme editor: a re-rendered section delivers a fresh node — adopt it, kill the zombie
    document.addEventListener('shopify:section:load', function (e) {
      var fresh = e.target && e.target.querySelector && e.target.querySelector('#HagaPickupDock');
      if (!fresh || fresh === dockEl) return;
      ++seq;
      if (activeCheckout) finishCheckout(activeCheckout);
      dockEl.remove();
      dockEl = fresh;
      sourceEl = dockEl.closest('.haga-pickup-source');
      sectionId = sourceEl && sourceEl.dataset.sectionId;
      populateDates(dockEl);
      fillSlots(dockEl);
      ensureDocked();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (sourceEl && e.target && e.target.contains && !document.contains(sourceEl)) dockEl.remove();
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { cartChanging = false; if (activeCheckout) finishCheckout(activeCheckout); ensureDocked(); refreshData(); }    // bfcache return: clear submit latch (prior submit navigated away) + re-dock
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-policies"] && !Shopify.designMode) return;
  try {
    
  /* The footer policies are an accordion on mobile only. The <details> ships `open` (so desktop
     shows the row even with no JS / in Safari + Firefox); this collapses it on mobile and re-syncs
     on breakpoint change. Failure mode is "links visible", never "gone". */
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      document.querySelectorAll('.haga-policies__group').forEach(function (d) {
        if (mq.matches) { d.removeAttribute('open'); } else { d.setAttribute('open', ''); }
      });
    }
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); } else { mq.addListener(sync); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-product-grid"] && !Shopify.designMode) return;
  try {
    
  /* auto-apply filters the moment a value changes (no separate Apply button) */
  document.addEventListener('change', (event) => {
    const form = event.target.closest('.haga-grid__filters');
    if (!form) return;
    /* price-range number inputs fire `change` on blur — auto-submitting reloads before the second
       value can be typed, making the range unusable. Let it apply on Enter (native submit). (Postel) */
    if (event.target.matches('input[type="number"]')) return;
    /* pending feedback: the submit is a full reload — dim the stale grid. (No aria-busy: the grid
       isn't a live region, so it'd be inert for SR — MDN; the dim is a sighted-only cue.) */
    const list = document.querySelector('.haga-grid__list');
    if (list) { list.classList.add('is-loading'); }
    form.submit();
  });

  /* the filter/sort dropdowns are native <details>, which stay open independently. Make them behave
     like a menu: opening one closes the others (accordion), and a click outside or Escape closes any
     open one. (toggle doesn't bubble → capture phase. Setting o.open=false re-fires toggle but the
     d.open guard skips it, so no loop.) Inert on pages with no .haga-grid__filter. */
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (!(d.classList && d.classList.contains('haga-grid__filter'))) return;   // ignore any other <details>
    /* No aria-expanded sync: native <details>/<summary> already exposes the open state to AT. */
    if (d.open) {
      const bar = d.closest('.haga-grid__filters-bar');
      if (bar) bar.querySelectorAll('.haga-grid__filter[open]').forEach((o) => { if (o !== d) o.open = false; });
    }
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('.haga-grid__filter')) return;
    document.querySelectorAll('.haga-grid__filter[open]').forEach((o) => { o.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.haga-grid__filter[open]').forEach((o) => {
        o.open = false;
        const s = o.querySelector('summary');
        if (s) s.focus();   // Escape-close returns focus to the disclosure button — else focus dies inside the hidden panel (WCAG 2.4.3). The outside-click close above deliberately does NOT steal focus (the user clicked elsewhere).
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haga-section"] && !Shopify.designMode) return;
  try {
    
  /* The watermark <haga-logo> fades out as the page scrolls — over the first --logo-scroll-distance,
     from --logo-start-opacity → --logo-end-opacity. Chrome-family browsers do this in pure CSS
     (animation-timeline: scroll(), gated by @supports above). The second IIFE below is the FALLBACK
     that drives the same fade with a passive scroll listener for browsers that lack scroll-timeline
     support (Firefox, older Safari); CSS.supports gates it so exactly one path runs. Reduced-motion:
     neither runs — the logo stays put. Tune the feel via the --logo-*-opacity / --logo-scroll-distance tokens. */

  // Respect prefers-reduced-motion for autoplaying block videos: pause them and
  // expose controls so the viewer can still opt in. CSS can't stop playback and
  // Liquid can't read the media query at render time, so this runs client-side.
  (function () {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function tameVideos() {
      if (!reduce.matches) return;
      document.querySelectorAll('.haga-section video[autoplay], .haga-footer video[autoplay]').forEach((video) => {
        video.removeAttribute('autoplay');
        video.pause();
        // decorative (aria-hidden) videos just pause — exposing a focusable control inside an
        // aria-hidden subtree is a WAI-ARIA anti-pattern. Real content videos still get controls.
        if (video.getAttribute('aria-hidden') !== 'true') {
          video.setAttribute('controls', '');
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tameVideos);
    } else {
      tameVideos();
    }
    // One-way by design: once tamed we leave videos tamed even if reduced-motion flips back OFF
    // mid-session — restarting autoplay under the viewer is jarring, and they still have controls.
    if (reduce.addEventListener) { reduce.addEventListener('change', tameVideos); } else if (reduce.addListener) { reduce.addListener(tameVideos); }   // old WebKit (Safari ≤13) lacks MQL.addEventListener — match the guarded siblings (haga-policies/haga-footer)
  })();

  // Watermark scroll-dim FALLBACK — the <haga-logo> custom element. It drives the same fade as the
  // CSS scroll-driven animation, but ONLY where that's unsupported (Firefox, older Safari): reads the
  // same --logo-* tokens and fades from start → end opacity over --logo-scroll-distance. As a custom
  // element it self-inits on connect (so the theme editor's shopify:section:load re-wires it for free)
  // and tears its global listeners down on disconnect — no orphaned window listeners, no document query.
  if (!customElements.get('haga-logo')) {
    customElements.define('haga-logo', class HagaLogo extends HTMLElement {
      connectedCallback() {
        // Gate 1: where the CSS scroll-timeline fade is supported it owns the animation — JS stays out.
        if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'scroll()')) return;
        // Gate 2 (one-shot, not a live 'change' listener): if reduced-motion is on at load we skip the
        // JS fade; the @media (prefers-reduced-motion) stylesheet block parks the logo statically, so a
        // mid-session toggle is already covered by CSS — no JS needed here.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const root = document.documentElement;
        const toPx = (token) => {
          const n = parseFloat(token) || 0;
          if (token.indexOf('vh') > -1) return (n * window.innerHeight) / 100;
          if (token.indexOf('rem') > -1) return n * parseFloat(getComputedStyle(root).fontSize);
          return n; // px / unitless
        };
        this._ticking = false;
        this._start = 1; this._end = 0; this._dist = window.innerHeight;
        this._measure = () => {   // static tokens — recompute on resize only (dist is vh-based), never per scroll frame
          const cs = getComputedStyle(this);
          this._start = parseFloat(cs.getPropertyValue('--logo-start-opacity')) || 1;
          this._end = parseFloat(cs.getPropertyValue('--logo-end-opacity')) || 0;
          this._dist = toPx(cs.getPropertyValue('--logo-scroll-distance').trim()) || window.innerHeight;
        };
        this._update = () => {
          this._ticking = false;
          const p = this._dist > 0 ? Math.min(1, Math.max(0, window.scrollY / this._dist)) : 1;
          this.style.setProperty('--logo-opacity', (this._start + (this._end - this._start) * p).toFixed(3));
        };
        this._onScroll = () => { if (!this._ticking) { this._ticking = true; requestAnimationFrame(this._update); } };
        this._onResize = () => { this._measure(); this._onScroll(); };
        this._measure(); this._update();
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });
      }
      disconnectedCallback() {
        // Symmetric teardown — both gates above can return before these are bound, so guard.
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }
    });
  }

  // Masonry stagger — positions the editorial cards into a true brick pack ONLY where native masonry
  // (display: grid-lanes) is absent. Each card is placed, in source order, into the currently-shortest
  // column via transform, so the DOM/tab order is never reshuffled (a11y) while the layout packs tight.
  // The CSS grid rule is the no-JS base; this is a progressive enhancement that self-eliminates as
  // browsers ship grid-lanes. Recomputes on resize, image load, and theme-editor block changes — and
  // RE-QUERIES the section element each pass so it survives the editor re-rendering it on reorder.
  (function () {
    if (window.CSS && CSS.supports && CSS.supports('display', 'grid-lanes')) return;
    let scheduled = false;
    function px(cs, prop) { return parseFloat(cs[prop]) || 0; }
    function layout() {
      scheduled = false;
      const comp = document.querySelector('.haga-section .haga-composition--masonry');  // re-query: the editor replaces this element on block reorder/edit
      if (!comp) return;
      const items = Array.prototype.filter.call(comp.children, function (el) { return el.nodeType === 1; });
      if (!items.length) return;
      const cs = getComputedStyle(comp);   // one read per pass — reused for grid template + gaps below
      const tpl = cs.gridTemplateColumns;
      const cols = (tpl && tpl !== 'none') ? tpl.split(' ').length : 1;
      if (cols <= 1) {   // mobile single-column flow — clear positioning, let CSS handle it
        comp.classList.remove('is-js-masonry');
        comp.style.height = '';
        items.forEach(function (el) { el.style.width = ''; el.style.transform = ''; });
        return;
      }
      comp.classList.add('is-js-masonry');
      const gapX = px(cs, 'columnGap'), gapY = px(cs, 'rowGap'), W = comp.clientWidth;
      const colW = (W - (cols - 1) * gapX) / cols;
      const colH = []; for (let i = 0; i < cols; i++) colH[i] = 0;
      items.forEach(function (el) {
        el._full = el.classList.contains('haga-block--chapter') || el.classList.contains('haga-block--quote') || el.classList.contains('haga-block--location');
        el.style.width = (el._full ? W : colW) + 'px';
      });
      items.forEach(function (el) {
        const h = el.offsetHeight;
        if (el._full) {
          const y = Math.max.apply(null, colH);
          el.style.transform = 'translate(0px,' + y + 'px)';
          for (let k = 0; k < cols; k++) colH[k] = y + h + gapY;
        } else {
          let c = 0; for (let j = 1; j < cols; j++) if (colH[j] < colH[c]) c = j;
          el.style.transform = 'translate(' + (c * (colW + gapX)) + 'px,' + colH[c] + 'px)';
          colH[c] += h + gapY;
        }
      });
      comp.style.height = (Math.max.apply(null, colH) - gapY) + 'px';
      Array.prototype.forEach.call(comp.querySelectorAll('img'), function (img) { if (!img.complete && !img._mBound) { img._mBound = true; img.addEventListener('load', schedule, { once: true }); } });
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(layout); } }
    /* BOOTSTRAP (hardened 2026-07-04): the old guard `if (!querySelector(masonry)) return;` ran at
       SCRIPT time — if the script executes before the section's DOM (script placement is the
       platform's call, not ours), it early-returned PERMANENTLY: no listeners, masonry silently
       degrades to the row-aligned grid fallback forever (caught live in preview tonight — the
       zero-match lie, JS edition). init() re-checks at DOM-ready instead, and only binds where
       a masonry composition actually exists. */
    function init() {
      if (!document.querySelector('.haga-section .haga-composition--masonry')) return;   // genuinely not a masonry page
      schedule();
      window.addEventListener('load', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('shopify:section:load', schedule);
      document.addEventListener('shopify:section:reorder', schedule);
      document.addEventListener('shopify:block:select', schedule);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  /* Live Instagram: fill every _haga-social "latest post" <img> from the Behold JSON feed. Tiles that
     share a feed are filled in DOM order (1st → newest, 2nd → next…) from a SINGLE fetch, so a whole
     grid of IG blocks needs one request. link_target='post' swaps the tile's link to that post's
     permalink. No-op on pages without any; on failure the fallback (picker image / pink frame) stays. */
  (function () {
    var IG_MONTHS = ['januari','februari','mars','april','maj','juni','juli','augusti','september','oktober','november','december'];
    function igDate(ts) { var s = String(ts).replace(/([+-]\d{2})(\d{2})$/, '$1:$2'); var d = new Date(s); return isNaN(d.getTime()) ? '' : d.getDate() + ' ' + IG_MONTHS[d.getMonth()]; }   // normalize +0000 → +00:00; WebKit/Safari rejects the colon-less offset Behold sends and would blank the date
    function fillIG() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('img.haga-social__live[data-behold-feed]'));
    if (!imgs.length) return;
    var groups = {};
    imgs.forEach(function (img) {
      var url = img.getAttribute('data-behold-feed');
      if (url && !img.dataset.beholdDone) { img.dataset.beholdDone = '1'; (groups[url] = groups[url] || []).push(img); }
    });
    Object.keys(groups).forEach(function (url) {
      fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
        var posts = (data && data.posts) || [];
        if (!posts.length) return;
        groups[url].forEach(function (img, i) {
          var card = img.closest('.haga-block');   // _haga-social tile OR _haga-chapter row
          var p = posts[i];
          if (!p) { if (card) card.hidden = true; return; }   // fewer posts than tiles → hide the extra
          var s = p.sizes || {};
          var src = (s.large && s.large.mediaUrl) || (s.medium && s.medium.mediaUrl) || p.mediaUrl;
          if (src) {
            var set = [];
            if (s.small && s.small.mediaUrl) set.push(s.small.mediaUrl + ' 400w');
            if (s.medium && s.medium.mediaUrl) set.push(s.medium.mediaUrl + ' 700w');
            if (s.large && s.large.mediaUrl) set.push(s.large.mediaUrl + ' 1000w');
            if (set.length) { img.srcset = set.join(', '); img.sizes = '(min-width: 750px) 38vw, 75vw'; }
            img.src = src;
          }
          var cap = (p.prunedCaption || p.caption || '').replace(/\s+/g, ' ').trim();
          var capEl = card && card.querySelector('[data-behold-caption]');
          if (capEl) capEl.textContent = cap;
          // If a visible caption renders, it names the link (alt empty). If not (image-only landing
          // tiles), the caption becomes the image's alt so the link still has an accessible name.
          img.alt = capEl ? '' : (cap || 'Inlägg från Instagram');
          var handleEl = card && card.querySelector('[data-behold-handle]');
          if (handleEl) handleEl.textContent = data.username || 'hagabageri';
          var dateEl = card && card.querySelector('[data-behold-date]');
          if (dateEl && p.timestamp) { var igd = igDate(p.timestamp); dateEl.textContent = igd ? ' · ' + igd : ''; }   // prepend the separator WITH the date so an empty/failed date leaves no dangling "·"
          if (img.getAttribute('data-behold-link') === 'post' && p.permalink && card) {
            card.querySelectorAll('.haga-stretched-link, a.haga-read-more').forEach(function (a) { a.href = p.permalink; a.target = '_blank'; a.rel = 'noopener noreferrer'; });   // external IG post → new tab (keep the storefront session)
            var sl = card.querySelector('.haga-stretched-link');
            if (sl && cap) sl.setAttribute('aria-label', cap.slice(0, 80));   // per-post link name (WCAG 2.4.4) — else every IG tile/row shares the static "Senaste inlägget på Instagram"
          }
        });
        window.dispatchEvent(new Event('resize'));   // images/captions changed heights — re-run the masonry
      }).catch(function () {});
    });
    }
    fillIG();
    document.addEventListener('shopify:section:load', fillIG);   // editor re-renders a section → re-fill its tiles/rows so it doesn't blank out
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
